import { GROUP_CONTENT_TYPES } from '../constants';

/**
 * Checks contentType if it is one of the group content types
 *
 * @param {string} contentType
 * @returns {Bool}
 */
export const isGroup = (contentType) => GROUP_CONTENT_TYPES.has(contentType);
